
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rivals/[id]/recruiting/[recruitingId]/interests",
      function () {
        return require("private-next-pages/rivals/[id]/recruiting/[recruitingId]/interests.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rivals/[id]/recruiting/[recruitingId]/interests"])
      });
    }
  